import { useState } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { FaWhatsapp } from "react-icons/fa";

export default function Calorie() {

    const [gender, setGender] = useState("male");
    const [age, setAge] = useState("");
    const [height, setHeight] = useState("");
    const [weight, setWeight] = useState("");

    const [bmr, setBmr] = useState(null);
    const [maintenance, setMaintenance] = useState(null);
    const [fatLoss, setFatLoss] = useState(null);
    const [muscleGain, setMuscleGain] = useState(null);
    const [tips, setTips] = useState([]);

    function calculateCalories() {

        if (!age || !height || !weight) {
            alert("Please fill all fields");
            return;
        }

        let calculatedBMR = 0;

        if (gender === "male") {
            calculatedBMR =
                (10 * weight) +
                (6.25 * height) -
                (5 * age) +
                5;
        }
        else {
            calculatedBMR =
                (10 * weight) +
                (6.25 * height) -
                (5 * age) -
                161;
        }

        const maintenanceCalories =
            Math.round(calculatedBMR * 1.55);

        const fatLossCalories =
            Math.round(maintenanceCalories - 500);

        const muscleGainCalories =
            Math.round(maintenanceCalories + 300);

        setBmr(Math.round(calculatedBMR));
        setMaintenance(maintenanceCalories);
        setFatLoss(fatLossCalories);
        setMuscleGain(muscleGainCalories);

        setTips([
            `Consume around ${maintenanceCalories} calories to maintain your current weight.`,
            `For fat loss, aim for approximately ${fatLossCalories} calories per day.`,
            `For muscle gain, consume around ${muscleGainCalories} calories daily.`,
            "Prioritize protein intake and resistance training.",
        ]);
    }

    return (
        <>
            <title>Calorie Calculator | The Fitness Expert - Calculate Your Daily Calorie Needs</title>
            <meta name="description" content="Use The Fitness Expert's free Calorie Calculator to estimate your daily calorie requirements based on your age, gender, height, weight, and activity level. Plan your diet for weight loss, muscle gain, or weight maintenance." />
            <meta name="keywords" content="calorie calculator, daily calorie calculator, TDEE calculator, BMR calculator, calories per day, weight loss calculator, muscle gain calculator, maintenance calories, nutrition calculator, fitness calculator, calorie intake calculator, calorie deficit calculator, The Fitness Expert" />
            <meta property="og:title" content="Free Calorie Calculator | The Fitness Expert" />
            <meta property="og:site_name" content="The Fitness Expert" />
            <meta property="og:url" content="https://thefitnessexpert.in/user/Calorie" />
            <meta property="og:description" content="Calculate your daily calorie needs with The Fitness Expert's free Calorie Calculator. Find your maintenance calories, calorie deficit, and calorie surplus for your fitness goals." />
            <meta property="og:image" content="logo.png"></meta>
            <meta name="twitter:card" content="app" />
            <meta name="twitter:site" content="@thefitnessexpert" />
            <meta name="twitter:description" content="Calculate your daily calorie needs with The Fitness Expert's free Calorie Calculator. Find your maintenance calories, calorie deficit, and calorie surplus for your fitness goals." />
            <meta name="twitter:app:country" content="India" />
            <Navbar />
            <section className="py-5 bgcalorie">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-6">
                            <div className="card p-4 border-0 shadow-lg rounded-4 calcard">
                                <div className="mb-3">
                                    <label className="form-label text-white">Gender</label>
                                    <select className="form-select" value={gender} onChange={(e) => setGender(e.target.value)}>
                                        <option value="male">Male</option>
                                        <option value="female">Female</option>
                                    </select>
                                </div>
                                <div className="mb-3">
                                    <label className="form-label text-white">Age</label>
                                    <input type="number" className="form-control" value={age} onChange={(e) => setAge(e.target.value)} />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label text-white">Height (cm)</label>
                                    <input type="number" className="form-control" value={height} onChange={(e) => setHeight(e.target.value)} />
                                </div>
                                <div className="mb-4">
                                    <label className="form-label text-white">Weight (kg)</label>
                                    <input type="number" className="form-control" value={weight} onChange={(e) => setWeight(e.target.value)} />
                                </div>
                                <button className="btn btn-danger w-100" onClick={calculateCalories}>
                                    Calculate Calories
                                </button>
                                {maintenance && (
                                    <div className="mt-4">
                                        <div className="row g-3">
                                            <div className="col-md-6">
                                                <div className="result-card">
                                                    <small className="text-secondary">BMR</small>
                                                    <h1 className="text-info h3">
                                                        {bmr} kcal
                                                    </h1>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="result-card">
                                                    <small className="text-secondary">
                                                        Maintenance Calories
                                                    </small>
                                                    <h2 className="text-success h3">
                                                        {maintenance} kcal
                                                    </h2>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="result-card">
                                                    <small className="text-secondary">
                                                        Fat Loss Calories
                                                    </small>
                                                    <h3 className="text-danger">
                                                        {fatLoss} kcal
                                                    </h3>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="result-card">
                                                    <small className="text-secondary">
                                                        Muscle Gain Calories
                                                    </small>
                                                    <h3 className="text-warning">
                                                        {muscleGain} kcal
                                                    </h3>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                {tips.length > 0 && (
                                    <div className="mt-4 result-card">
                                        <h5 className="text-white mb-3">Recommended Nutrition Tips</h5>
                                        <ul className="mb-0">
                                            {tips.map((tip, index) => (
                                                <li key={index} className="text-light mb-2">
                                                    🍎 {tip}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <div className="position-fixed bottom-0 end-0 p-3 z-3">
                <button className="fixed-join-btn text-light fw-bold px-3 py-2 shadow rounded-pill bgcolor"
                    onClick={() =>
                        window.open("https://wa.me/919876857579?text=Hello%20Harman%20Sir%20👋%0A%0AI%20visited%20your%20website%20and%20I'm%20interested%20in%20your%20fitness%20coaching%20programs.", "_blank"
                        )}>
                    <FaWhatsapp size={24} />
                </button>
            </div>
            <Footer />
        </>
    )
}